export const AGENT_INSTRUCTIONS_HINT =
  'Paste this into your agent to set it up with the Buffer API.'

export const AGENT_INSTRUCTIONS = `Help me set up the Buffer API.

Read https://developers.buffer.com/guides/agent-setup.md and follow it.

Do not create, edit or delete anything without asking me first.`
